// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1s89M","video":"Home_video__aWAxW"};